var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Field__Component" }, [
    _c(
      "div",
      {
        staticStyle: {
          cursor: "pointer",
          "text-align": "center",
          width: "70px",
        },
        on: {
          click: function ($event) {
            $event.stopPropagation()
            return _vm.previewQuestion.apply(null, arguments)
          },
        },
      },
      [
        _vm._t("default", function () {
          return [_c("b-icon", { attrs: { pack: "fa", icon: "eye" } })]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }